import {Element} from "@craftjs/core";

import React from "react";
import {Title} from "@/src/components/Title";
import {Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious} from "@/src/components/ui/carousel";
import { Box } from "@/src/components/Box";

export function CarouselPrimitive (props: any) {
    const {options} = props;
    return (
        <Carousel className={"w-full"} opts={{align: "start", loop: true}}>
            <div className="flex items-center justify-between mb-6">
                <Element
                    is={Title}
                    id={"carousel-title"}
                    text={"Можливо, вас зацікавить:"}
                    size={"h3"}
                    background={"#234678"}
                />
                <div className={"flex gap-2"}>
                    <CarouselPrevious/>
                    <CarouselNext/>
                </div>
            </div>
            <CarouselContent>
                {options?.map((item: {value: string}) => (
                    <CarouselItem key={item.value} className={"md:basis-1/2 lg:basis-1/3"}>
                        <Element is={Box} canvas id={`product-${item.value}`} style={{padding: 0, height: "100%"}}/>
                    </CarouselItem>
                ))}
            </CarouselContent>
        </Carousel>
    );
};
